var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1436 0C9.59127 0 9.14355 0.447715 9.14355 1V5C9.14355 5.55228 9.59127 6 10.1436 6C10.6958 6 11.1436 5.55228 11.1436 5V1C11.1436 0.447715 10.6958 0 10.1436 0ZM10.1426 14.2856C9.59029 14.2856 9.14258 14.7334 9.14258 15.2856V19.2856C9.14258 19.8379 9.59029 20.2856 10.1426 20.2856C10.6949 20.2856 11.1426 19.8379 11.1426 19.2856V15.2856C11.1426 14.7334 10.6949 14.2856 10.1426 14.2856ZM19.2861 9.14307C19.8384 9.14307 20.2861 9.59078 20.2861 10.1431C20.2861 10.6954 19.8384 11.1431 19.2861 11.1431H15.2861C14.7338 11.1431 14.2861 10.6954 14.2861 10.1431C14.2861 9.59078 14.7338 9.14307 15.2861 9.14307H19.2861ZM6 10.1426C6 9.59029 5.55228 9.14258 5 9.14258H1C0.447715 9.14258 0 9.59029 0 10.1426C0 10.6949 0.447715 11.1426 1 11.1426H5C5.55228 11.1426 6 10.6949 6 10.1426ZM17.3154 15.9008C17.7059 16.2913 17.7059 16.9245 17.3154 17.315C16.9248 17.7055 16.2917 17.7055 15.9011 17.315L13.0727 14.4866C12.6822 14.0961 12.6822 13.4629 13.0727 13.0724C13.4632 12.6819 14.0964 12.6819 14.4869 13.0724L17.3154 15.9008ZM7.21379 7.21321C7.60432 6.82269 7.60432 6.18952 7.21379 5.799L4.38537 2.97057C3.99484 2.58004 3.36168 2.58004 2.97115 2.97057C2.58063 3.36109 2.58063 3.99426 2.97115 4.38478L5.79958 7.21321C6.1901 7.60373 6.82327 7.60373 7.21379 7.21321ZM15.9013 2.97102C16.2918 2.5805 16.925 2.5805 17.3155 2.97102C17.706 3.36155 17.706 3.99471 17.3155 4.38524L14.4871 7.21366C14.0966 7.60419 13.4634 7.60419 13.0729 7.21366C12.6823 6.82314 12.6823 6.18997 13.0729 5.79945L15.9013 2.97102ZM7.21394 13.0721C6.82342 12.6816 6.19025 12.6816 5.79973 13.0721L2.9713 15.9005C2.58078 16.291 2.58078 16.9242 2.9713 17.3147C3.36183 17.7053 3.99499 17.7053 4.38552 17.3147L7.21394 14.4863C7.60447 14.0958 7.60447 13.4626 7.21394 13.0721Z",
    fill: "url(#paint0_angular_7404_52730)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_7404_52730",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1431 10.1428) rotate(-74.269) scale(10.5375 10.5378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C6FF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6FF5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading-icon.39ed0ddb701903ff69f0c1eb6ad2fd0b.svg";